
import React from "react";
import {
  Globe2,
  Users2,
  Cpu,
  Lightbulb,
  Handshake,
  Network,
} from "lucide-react";

// Images for the principles (ensure these image files exist in your public/Images directory)
const principleImages = [
  "/Images/image6.jpeg",
  "/Images/image8.jpeg",
  "/Images/image3.jpeg",
  "/Images/image5.jpeg",
];

// Images for the stats/highlights (ensure these image files exist in your public/Images directory)
const statsImages = [
  "/Images/global-reach.jpg",
  "/Images/collaborative-growth.jpg",
  "/Images/inclusive-economy.jpg",
  "/Images/tech-integration.jpg",
];

const CorePrinciples = () => {
  const principles = [
    {
      title: "Inclusivity",
      desc: "Promoting shared prosperity by empowering women-led enterprises, youth, and underrepresented sectors.",
      icon: <Users2 className="w-10 h-10 text-[#4FB1FF]" />,
      image: principleImages[0],
    },
    {
      title: "Innovation & Technology",
      desc: "Supporting digital transformation, e-commerce, and smart cross-border trade practices.",
      icon: <Cpu className="w-10 h-10 text-[#FFD700]" />,
      image: principleImages[1],
    },
    {
      title: "Strategic Impact",
      desc: "Identifying opportunities, adapting to global shifts, and fostering sustainable growth.",
      icon: <Lightbulb className="w-10 h-10 text-[#4FB1FF]" />,
      image: principleImages[2],
    },
    {
      title: "Collaborative Network",
      desc: "Building a resilient global ecosystem through partnerships, mentorship, and knowledge sharing.",
      icon: <Handshake className="w-10 h-10 text-[#FFD700]" />,
      image: principleImages[3],
    },
  ];

  const stats = [
    {
      title: "Global Reach",
      desc: "Connecting India and Europe through strategic partnerships.",
      icon: <Globe2 className="w-10 h-10 text-[#4FB1FF] mx-auto" />,

    },
    {
      title: "Collaborative Growth",
      desc: "Fostering unity, innovation, and sustainable development.",
      icon: <Network className="w-10 h-10 text-[#FFD700] mx-auto" />,

    },
    {
      title: "Inclusive Economy",
      desc: "Empowering women, youth, and small enterprises.",
      icon: <Users2 className="w-10 h-10 text-[#4FB1FF] mx-auto" />,

    },
    {
      title: "Tech Integration",
      desc: "Bridging tradition and technology for modern trade.",
      icon: <Cpu className="w-10 h-10 text-[#FFD700] mx-auto" />,

    },
  ];

  return (
    <section className="bg-[#F8FAFC] py-20">
      <div className="container mx-auto px-6 lg:px-16">
        {/* Section Header */}
        <div className="text-center mb-16">
          {/* <h5 className="uppercase text-[#4FB1FF] tracking-wider text-sm font-semibold mb-3">
            Our Core Principles
          </h5> */}
          <h2 className="text-5xl md:text-6xl font-Agatho_Regular  font-extrabold text-[#0B1D33] mb-4">
            Driving <span className="">Collaboration</span> &{" "}
            <span className="">Impact</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto font-bold text-xl leading-relaxed  font-Agatho_Regular ">
            Enabling inclusive, innovative, and sustainable growth for  businesses across
            <br /> 
            <span className="font-bold text-2xl md:text-2xl">
              India and Europe.
            </span>
       
          </p>
        </div>

        {/* Principle Cards */}
        <div className="grid lg:grid-cols-2 gap-8 mb-16">
          {principles.map((p, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl p-8 flex text-center flex-col gap-4 transition"
            >
              <div className="mb-3 w-full h-[250px] relative flex justify-center items-center">
                {/* Icon on top left */}
                <span
                  className="absolute top-4 left-4 bg-white rounded-full p-3 shadow-md z-20"
                  style={{ zIndex: 3 }}
                >
                  {p.icon}
                </span>
                <img
                  src={p.image}
                  alt={`${p.title} visual`}
                  className="object-cover w-full h-full rounded-2xl"
                  style={{ position: "absolute", top: 0, left: 0, zIndex: 1 }}
                  loading="lazy"
                />
              </div>
              <h3 className="text-3xl font-Agatho_Regular font-semibold text-[#0B1D33]">
                {p.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* Stats / Quick Highlights */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center mt-10">
          {stats.map((s, i) => (
            <div key={i} className="flex flex-col items-center">
              <div className="w-20 h-20 mb-2 relative flex justify-center items-center">
              
                <span
                  className="relative bg-white/80 rounded-full p-2 shadow-md flex items-center justify-center"
                  style={{ zIndex: 2 }}
                >
                  {s.icon}
                </span>
              </div>
              <h4 className="font-semibold mt-3 text-[#0B1D33]">{s.title}</h4>
              <p className="text-gray-600 text-sm mt-1">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CorePrinciples;
